var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pricing-import',{staticClass:"everyday-pricing-import",attrs:{"formName":"everyday-pricing-import","moduleSlug":"everyday-pricing-import","controllerName":"EverydayPricingImport.vue","moduleName":"Everyday Pricing Import","priceTypeId":"3"}})
}
var staticRenderFns = []

export { render, staticRenderFns }